import { render, staticRenderFns } from "./ErrorTab.vue?vue&type=template&id=596f93c8&"
import script from "./ErrorTab.vue?vue&type=script&lang=js&"
export * from "./ErrorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports